<template>
  <div class="bg-white rounded-sm m-2">
    <b-row>
      <b-modal title="Application Details" ref="applicationDetails" size="xl" hide-footer>
        <BsiContinuousFilingDetails :tracking-number="trackingNumber" :nature="nature"/>
      </b-modal>
    </b-row>
    <b-row>
      <b-col cols="12" class="mx-3 mt-3">
        <b-row>
          <span class="title">Building Society Continuous Filing Applications</span>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="flex mx-3 mt-3">
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="pre-waiting">
          <span v-if="getBsiContinuousFilingStatistics.draft === undefined" class="h3 mx-auto">0</span>
          <span v-else class="h3 mx-auto">{{getBsiContinuousFilingStatistics.draft.toLocaleString()}}</span>
        </div>
        <div class="pre-waiting">
          <span class="text-sm mx-auto">Drafts</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="waiting">
          <span v-if="getBsiContinuousFilingStatistics.pending === undefined" class="h3 mx-auto">0</span>
          <span v-else class="h3 mx-auto">{{getBsiContinuousFilingStatistics.pending.toLocaleString()}}</span>
        </div>
        <div class="waiting">
          <span class="text-sm mx-auto">In Queue</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="normal">
          <span v-if="getBsiContinuousFilingStatistics.assigned === undefined" class="h3 mx-auto">0</span>
          <span v-else class="h3 mx-auto">{{getBsiContinuousFilingStatistics.assigned.toLocaleString()}}</span>
        </div>
        <div class="normal">
          <span class="text-sm mx-auto">Assigned</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="off-normal">
          <span v-if="getBsiContinuousFilingStatistics.assigned === undefined" class="h3 mx-auto">0</span>
          <span v-else class="h3 mx-auto">{{getBsiContinuousFilingStatistics.escalated.toLocaleString()}}</span>
        </div>
        <div class="off-normal">
          <span class="text-sm mx-auto">Escalated</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="warning">
          <span v-if="getBsiContinuousFilingStatistics.queried === undefined" class="h3 mx-auto">0</span>
          <span v-else class="h3 mx-auto">{{getBsiContinuousFilingStatistics.queried.toLocaleString()}}</span>
        </div>
        <div class="warning">
          <span class="text-sm mx-auto">Queried</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="positive">
          <span v-if="getBsiContinuousFilingStatistics.approved === undefined" class="h3 mx-auto">0</span>
          <span v-else class="h3 mx-auto">{{getBsiContinuousFilingStatistics.approved.toLocaleString()}}</span>
        </div>
        <div class="positive">
          <span class="text-sm mx-auto">Approved</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="warning-secondary">
          <span v-if="getBsiContinuousFilingStatistics.total === undefined" class="h3 mx-auto">0</span>
          <span class="h3 mx-auto">{{getBsiContinuousFilingStatistics.total.toLocaleString()}}</span>
        </div>
        <div class="warning-secondary">
          <span class="text-sm mx-auto">Total</span>
        </div>
      </div>

    </b-row>
    <b-row class="flex">
      <b-col cols="12">
        <b-row class="pt-3">
          <b-col>
            <AllBsiContinuousFilingSubmissions v-on:openDetails="openDetails"/>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";

import AllBsiContinuousFilingSubmissions
    from "@/views/home/services/bsi-continuous-filing/submissions/AllBsiContinuousFilingSubmissions.vue";
import BsiContinuousFilingDetails
    from "@/views/home/services/bsi-continuous-filing/submissions/BsiContinuousFilingDetails.vue";

export default {
  name: "BsiContinuousFilingApplications",
  components: {
      BsiContinuousFilingDetails,
      AllBsiContinuousFilingSubmissions,
  },
  data(){
    return{
      currentRoute: "pending",
      trackingNumber:null,
        nature :"management-applications"
    }
  },
  mounted() {
    this.fetchBsiContinuousFilingStats("RESOLUTION,MANAGEMENT_METADATA")
  },
  methods:{
    ...mapActions(["fetchBsiContinuousFilingStats"]),
    select(route){
      this.currentRoute = route
    },
    canViewMenuItem(permission) {
      return this.$can(permission, "general");
    },
    openDetails(data){
      this.trackingNumber = data.trackingNo
        if (data.filingType === 'MANAGEMENT_METADATA'){
            this.nature = "management-applications"
        } else if (data.filingType === "RESOLUTION"){
            this.nature = "resolutions"
        }
      this.$refs.applicationDetails.show()
    }
  },
  computed:{
    ...mapGetters(["getBsiContinuousFilingStatistics"])
  }
}
</script>

<style scoped>
@import "../../../../../assets/styles/menu.css";

.pre-waiting{
  @apply flex text-gray_title;
}

.off-normal{
  @apply flex text-blue-light;
}

.waiting{
  @apply flex text-gray;
}

.normal{
  @apply flex text-blue;
}

.positive{
  @apply flex text-green;
}

.warning{
  @apply flex text-orange;
}

.warning-secondary{
  @apply flex text-flopurple;
}

.negative{
  @apply flex text-red-light;
}
.stat-count{
  display: inline;
  width: 12%;
  @apply my-1;
}

</style>